module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tables-section"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', [_vm._t("title")], 2), _vm._v(" "), _c('p', [_vm._t("text")], 2), _vm._v(" "), _c('div', {
    staticClass: "row tables justify-content-around d-none d-md-flex"
  }, _vm._l((_vm.tables), function(table, index) {
    return _c('div', {
      key: index,
      staticClass: "card col-md-8 col-lg-5 px-0"
    }, [_c('div', {
      staticClass: "card-body"
    }, [_c('span', {
      staticClass: "card-title text-center mb-0"
    }, [_vm._v(_vm._s(table.title))]), _vm._v(" "), _vm._l((table.rows), function(row, index) {
      return _c('div', {
        key: index,
        staticClass: "row table-row"
      }, [_c('div', {
        staticClass: "col-4 row-title"
      }, [_vm._v(_vm._s(row.title))]), _vm._v(" "), _c('div', {
        staticClass: "col-8 row-value"
      }, [_vm._v(_vm._s(row.value))])])
    })], 2)])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "row tables tables__mobile d-md-none"
  }, _vm._l((_vm.tables), function(table, index) {
    return _c('div', {
      key: index,
      staticClass: "card w-100 px-0"
    }, [_c('div', {
      staticClass: "card-body"
    }, [_c('span', {
      staticClass: "card-title text-center mb-0 border-bottom-0"
    }, [_vm._v(_vm._s(table.title))]), _vm._v(" "), _vm._l((table.rows), function(row, index) {
      return _c('div', {
        key: index,
        staticClass: "table-row"
      }, [_c('div', {
        staticClass: "col row-title text-center"
      }, [_vm._v(_vm._s(row.title))]), _vm._v(" "), _c('div', {
        staticClass: "col row-value text-center"
      }, [_vm._v(_vm._s(row.value))])])
    })], 2)])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('router-link', {
    staticClass: "cta",
    attrs: {
      "to": "/get-start?step=1",
      "tag": "button"
    }
  }, [_vm._v(_vm._s(!!_vm.ctaButtonTitle ? "Get a quote" : "Get a quote"))])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9ee17956"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/industries/TablesSection.vue
// module id = 2005
// module chunks = 5